<template>
  <span>
    <el-button type="primary" plain size="mini" @click="dialogVisible = true">Move</el-button>
    <el-dialog title="Move Variant to Another Product" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" label-position="top" @submit.prevent.native="onSubmit">
        <el-form-item label="Target product ID">
          <el-input v-model="form.productId"></el-input>
        </el-form-item>
        <el-button type="primary" @click="onSubmit">Move</el-button>
        <el-button type="text" @click="dialogVisible = false">Cancel</el-button>
      </el-form>
    </el-dialog>
  </span>
</template>

<script>
export default {
  props: {
    productId: String,
    variantId: String,
  },

  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        productId: null,
      },
      rules: {
        'productId': [
          { required: true, message: 'Enter the target product ID.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.post('/product-variants/move', {
            product_id: this.productId,
            variant_id: this.variantId,
            target_product_id: this.form.productId,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$emit('update')
        this.dialogVisible = false
        this.$message.success(data.message)
      })
    },
  },
}
</script>
